import React, {useState } from 'react'
import { Field, Formik } from 'formik'
import Swal from "sweetalert2"
import { useNavigate } from 'react-router-dom'
import * as ticketService from '../../services/ticket.services';
import Breadcrums from '../../common/breadcrumbs';
import CustomCkeditor from '../../common/customeditor';
import { SWAL_SETTINGS } from '../../../../utils/Constants';
import { blockInvalidChar, handleServerValidations } from '../../../../utils/commonfunction';
import { TICKET_TYPES } from '../../../../utils/Constants'


const TicketAdd = (props) => {
    const navigate = useNavigate()
    const [submitted, setSubmitted] = useState(false)
    const breadcrumbs = [{ title: "Dashboard", url: "/admin/dashboard" }, { title: "Tickets", url: "/admin/event-management/tickets/list/1" }, { title: "Add", url: "" },]

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <Formik
                enableReinitialize
                initialValues={{
                    title: "",
                    ticket_type: "",
                    price: "",
                    person: "",
                    richtext: "",
                }}
                validate={values => {
                    const error = {};
                    if (!values.title || !values.title.trim()) error.title = "Title is required";
                    if (!values.ticket_type) error.ticket_type = "Type is required";
                    if (values.ticket_type === "paid") {
                        if (!values.price) error.price = "Price is required";
                    }
                    if (!values.person || !values.person.trim()) error.person = "No of persons is required";
                    if (!values.richtext || !values.richtext.trim()) error.richtext = "Description is required";
                    return error;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    setSubmitted(true)
                    let formData = new FormData();
                    formData.append('title', values.title);
                    formData.append('type', values.ticket_type);
                    if (values.ticket_type === "paid") {
                        formData.append('price', values.price);
                    }
                    formData.append('number_of_persons', values.person);
                    formData.append('description', values.richtext);
                    ticketService.Add(formData).then(response => {
                        setSubmitting(false);
                        if (response.success) {
                            Swal.fire({
                                icon: 'success',
                                text: response.message,
                                ...SWAL_SETTINGS
                            })
                            setTimeout(() => {
                                resetForm({ values: '' });
                                navigate(`/admin/event-management/tickets/list/1`)
                            }, 2000);
                        } else {
                            Swal.fire({
                                icon: 'error',
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS
                            })
                            setSubmitted(false)
                        }
                    }).catch(error => {
                        console.log("error ====> ", error);
                    })
                }}
            >{({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,

            }) => (
                <form onSubmit={handleSubmit}>
                    <div className="row row-sm">
                        <div className="col-lg-12 col-md-12 animation_fade">
                            <div className="card custom-card">
                                <div className="card-body">
                                    <div>
                                        <h6 className="main-content-label mb-3">Add Ticket</h6>
                                    </div>
                                    <div className="row row-sm">
                                        <div className='col-md-12 text-center form-group'>
                                            <label htmlFor='title' className='text-left d-flex'>Title:<span className="requirestar">*</span> </label>
                                            <input
                                                name='title'
                                                id='title'
                                                type='text'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.title}
                                                className='form-control' />
                                            <span className='text-danger d-flex text-left'>{errors.title && touched.title && errors.title}</span>
                                        </div>
                                        <div className='col-md-6 text-center form-group'>
                                            <label htmlFor='person' className='text-left d-flex'>Persons:<span className="requirestar">*</span></label>
                                            <input name='person' type='text' id="person" onChange={handleChange} onBlur={handleBlur} value={values.person} className='form-control' onKeyDown={blockInvalidChar} />
                                            <span className='text-danger d-flex text-left'>{errors.person && touched.person && errors.person}</span>
                                        </div>
                                        <div className="col-lg-6 text-center form-group">
                                            <label htmlFor='ticket_type' className='text-left d-flex'>Type:<span className="requirestar">*</span> </label>
                                            <div className="form-group select-down-arrow">
                                                <Field as='select' id="ticket_type" name={"ticket_type"} className="form-control select2 text-capitalize">
                                                    <option value="" label="Select">Select{" "}</option>
                                                    {TICKET_TYPES && Object.values(TICKET_TYPES).map((option, i) => {
                                                        return (
                                                            <option key={i} value={option}>
                                                                {option}
                                                            </option>
                                                        );
                                                    })}
                                                </Field>
                                                <span className='text-danger d-flex text-left'>{errors.ticket_type && touched.ticket_type && errors.ticket_type}</span>
                                            </div>
                                        </div>
                                        {values.ticket_type === "paid" ? <div className='col-md-6 text-center form-group'>
                                            <label htmlFor='price' className='text-left d-flex'>Price:<span className="requirestar">*</span></label>
                                            <input name='price' type='text' id="price" onChange={handleChange} onBlur={handleBlur} value={values.price} className='form-control' onKeyDown={blockInvalidChar} />
                                            <span className='text-danger d-flex text-left'>{errors.price && touched.price && errors.price}</span>
                                        </div> : ""}

                                        <div className='col-lg-12 text-center form-group'>
                                            <label htmlFor='subject' className='text-left d-flex'>Description:<span className="requirestar">*</span></label>
                                            <CustomCkeditor
                                                fieldname={"richtext"}
                                                setFieldValue={setFieldValue}
                                                value={values.richtext}
                                                setFieldTouched={setFieldTouched}
                                            />
                                            <span className='text-danger d-flex text-left'>{errors.richtext && touched.richtext && errors.richtext}</span>
                                        </div>

                                        <div className="">
                                            <button className="btn btn-main-primary signbtn mr-2" type="submit" disabled={submitted ? true : null}>
                                                <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                Submit
                                            </button>
                                            <button className="btn ripple btn-secondary" type='button' disabled={submitted ? true : null} onClick={() => navigate(-1)}>
                                                <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}
            </Formik>
        </>
    )
}

export default TicketAdd